import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ALL_ARTISTS_QUERY from '../../../../graphql/AllArtists';
import '../../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Banner from '../../../../components/Banner';
import Footer from '../../../../components/Footer';
import Sidebar from '../../../../components/Sidebar';
import ToggleUser from '../../User/Toggle';
import DeleteArtist from '../Delete';
import ToggleStats from '../ToggleStats';
import ToggleInfoType from '../ToggleInfoType';
import { IsAdmin } from '../../../../utils/Roles';


class ArtistList extends Component {
  componentWillMount() {
    if (!IsAdmin()) {
      this.props.history.push('/login');
    }
  }

  onLogout = () => {
    this.props.history.push('/login');
  };

  editActionFormatter = (cell, row) => (
    <div>
      <ToggleUser id={row.id} status={row.active} />
      <ToggleStats id={row.id} status={row.enabledStats} />
      <DeleteArtist id={row.id} onDelete={() => this.props.refetch()} />
    </div>
  );

  infoTypeFormatter = (cell, row) => (
    <div>
      <ToggleInfoType id={row.id} infoType={row.infoType} onAfterUpdate={this.props.refetch} />
    </div>
  );

  render() {
    const artists =
      this.props.artists &&
      this.props.artists.map(v => ({
        id: v.id,
        name: `${v.name} ${v.lastname}`,
        profession: v.profession,
        specialty: v.specialty,
        active: v.active,
        infoType: v.infoType,
        enabledStats: v.enabledStats,
      }));

    return (
      <div>
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="artists" onLogout={this.onLogout} />
              </div>

              <div className="col-lg-9 col-md-9 col-sm-12">
                <h1 className="heading">Mantenedor de Artistas</h1>

                <BootstrapTable
                  data={artists || []}
                  striped
                  hover
                  pagination
                >
                  <TableHeaderColumn isKey dataField="id" dataSort hidden>
                    ID
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="name"
                    dataSort
                    filter={{ type: 'TextFilter', delay: 300 }}
                  >
                    Nombre
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="profession"
                    dataSort
                    filter={{ type: 'TextFilter', delay: 300 }}
                  >
                    Profesión
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="specialty"
                    dataSort
                    filter={{ type: 'TextFilter', delay: 300 }}
                  >
                    Especialidad
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="infoType"
                    dataSort
                    dataFormat={this.infoTypeFormatter}
                  >
                    Ficha
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="action"
                    dataFormat={this.editActionFormatter}
                  >
                    Acciones
                  </TableHeaderColumn>
                </BootstrapTable>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const withArtists = graphql(ALL_ARTISTS_QUERY, {
  options: () => ({
    variables: { force: true },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => ({
    loading: data.loading,
    artists: data.allArtists,
    refetch: data.refetch,
  }),
});

export default withArtists(ArtistList);



// WEBPACK FOOTER //
// ./src/containers/Admin/Artist/List/index.js